import type { ActionContext } from "vuex";
import type { UserState } from "@/store/user/state";
import type { RootState } from "@/store/types";
import router from "@/router";
import type { NavigationFailure } from "vue-router";

/**
 * Clears the user & account from the user state.
 * @param context - on which the action is carried out.
 */
export function clearUser(context: ActionContext<UserState, RootState>): void {
  context.commit("setUser", { token: null });
  context.commit("setServiceGroups", { serviceGroups: [] });
}

/**
 * Log the currently logged-in user out of the application and return to the
 * login view.
 * @param context - on which the action is carried out.
 * @returns NavigationFailure if the navigation to the login view fails or void.
 */
export async function logUserOut(
  context: ActionContext<UserState, RootState>
): Promise<void | NavigationFailure> {
  clearUser(context);
  return router.push("/login");
}
